import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">专题合集</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">精心策划的综艺专题，按主题分类呈现，快速找到你想看的内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.slice(0, 4).map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-300 transition-all duration-300 no-underline cursor-pointer"
            >
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-heading text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <span className="px-2.5 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap">{item.count}</span>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
              <div className="mt-4 flex items-center gap-1 text-primary-600 text-sm font-medium">
                <span>浏览专题</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {indexData.slice(4).map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-300 transition-all duration-300 no-underline cursor-pointer"
            >
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-heading text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <span className="px-2.5 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full whitespace-nowrap">{item.count}</span>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
              <div className="mt-4 flex items-center gap-1 text-primary-600 text-sm font-medium">
                <span>浏览专题</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}